import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { DateService } from 'src/app/shared';

@Component({
  selector: 'app-hr-pickpoint-list',
  templateUrl: './../../../templates/forms/modals/pickpoint-list-two.component.html',
})
export class PickPointListComponent implements OnInit {
  @Input()
  config: any;
  
  @Input()
  modalShow: boolean = true;

  @Input()
  optionalParam: any;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrPickPoint"

  pickPointList: any[] = [];

  constructor(
      public langService: LangService
    , private dataService: DataLoadService
    , public gridService: GridService
    , public dateService: DateService) {
    this.colObj = [
      { headerName: langService.langData.dtlName, field: 'DTL_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.lookupDtlNo, field: 'LOOKUPDTL_NO', sortable: true, resizable: true, hide: false },
    ];
   }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
      this.grid = grid;
      this.gridService.sizeColumnsToFit(grid, this.gridId);
      this.dataService.load('FG_SA_COMM_CONFIGARATION', this.optionalParam).subscribe(result=>{
        this.pickPointList = result.body;
      })
    }
    itemClick(_item) {
      this.modalShow = false; 
      this.dataObj=_item;
      this.submit.next(_item);
    }

}
